import React from 'react';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import HeaderSearcherInput from '../../../../components/inputs/HeaderSearcherInput';
import FingoQuickFilter from '../../../../components/filters/FingoQuickFilter';
import RefreshButton from '../../../../components/buttons/RefreshButton';

const EvaluationInvoiceFilters = ({
  finder,
  setStates,
  states,
  buttonsToShow,
  onRefresh,
  refreshLoading,
  shouldLoadNewInvoices,
}) => (
  <>
    <Grid item xs={1.5} md={2} xl={2}>
      {onRefresh && (
        <RefreshButton
          onRefresh={onRefresh}
          loading={refreshLoading}
          id="evaluation-invoice-filters-refresh"
          shouldLoadNewInvoices={shouldLoadNewInvoices}
        />
      )}
    </Grid>
    <Grid item xs={10.5} md={4} xl={3}>
      <HeaderSearcherInput finder={finder} />
    </Grid>
    <Grid item xs={12} md={6} xl={7}>
      <FingoQuickFilter
        states={states}
        setStates={setStates}
        buttonsToShow={buttonsToShow}
        showDivider={false}
      />
    </Grid>
  </>
);

EvaluationInvoiceFilters.propTypes = {
  finder: PropTypes.shape({
    onFinderChange: PropTypes.func.isRequired,
    searchPlaceHolder: PropTypes.string.isRequired,
    finderValue: PropTypes.string.isRequired,
    canPasteExcel: PropTypes.bool,
    setColumnFilter: PropTypes.func,
  }),
  setStates: PropTypes.func,
  states: PropTypes.shape({
    dateIssued_Gte: PropTypes.string,
    dateIssued_Lte: PropTypes.string,
    availableForFinancing: PropTypes.string,
  }),
  buttonsToShow: PropTypes.arrayOf(PropTypes.string),
  onRefresh: PropTypes.func,
  refreshLoading: PropTypes.bool,
  shouldLoadNewInvoices: PropTypes.bool,
};

EvaluationInvoiceFilters.defaultProps = {
  finder: null,
  setStates: () => {},
  states: {},
  buttonsToShow: [],
  onRefresh: undefined,
  refreshLoading: false,
  shouldLoadNewInvoices: true,
};

export default EvaluationInvoiceFilters;
